import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    height: 100vh;
    height: 100dvh;
    max-height: 100dvh;
  }
`;

export const ModalContent = styled.div`
  background-color: #2d2d2d;
  padding: 40px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    width: 95%;
    padding: 24px;
    border-radius: 8px;
  }
`;

export const ModalHeader = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 600;
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    font-size: 22px;
    margin-bottom: 16px;
  }
`;

export const ModalText = styled.p`
  text-align: left;
  color: #ffffff;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
  
  strong {
    color: #ff6b35;
    font-weight: 600;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    font-size: 14px;
    margin-bottom: 12px;
  }
`;

export const AcceptButton = styled.button`
  background-color: #dc3545;
  color: white;
  padding: 14px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  transition: background-color 0.3s ease;
  margin-top: 8px;

  &:hover {
    background-color: #c82333;
  }

  &:disabled {
    background-color: #666;
    cursor: not-allowed;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    font-size: 16px;
    padding: 12px 16px;
  }
`;

export const CancelButton = styled.button`
  background-color: ${({ theme }) => theme.color?.spotifyDarkGrey || "#404040"};
  color: white;
  padding: 14px 20px;
  border: 1px solid ${({ theme }) => theme.color?.spotifyGrey || "#666"};
  border-radius: 8px;
  cursor: pointer;
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  transition: background-color 0.3s ease;
  margin-top: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.color?.spotifyLightGrey || "#555"};
  }

  &:disabled {
    background-color: #666;
    cursor: not-allowed;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoint?.miniMobile || 500}px) {
    font-size: 16px;
    padding: 12px 16px;
  }
`;
